import React from 'react';
import { observer } from 'mobx-react';
import initials from '../../../../../utils/string';
import moment from 'moment';

import { RootStoreContext } from '../../../../../context';

import './ConversationItem.css';

@observer
class ConversationItem extends React.Component {

  static contextType = RootStoreContext;

  activate = () => {
    const { openChat } = this.props;
    const hasUnreadMessages = openChat.hasUnreadMessages;
    if (openChat.subscribedToAnchor) {
      this.context.privateMessagingStore.activateConversation({ anchor: openChat.user.username }, hasUnreadMessages);
    } else {
      this.context.privateMessagingStore.activateConversation({ conversationName: openChat.name }, hasUnreadMessages);
    }
  }

  render () {
    const { openChat } = this.props;

    const { anchorSubscriptions, anchor } = this.context?.loggedInUser?.account || {};

    let className = 'flex anchor-chat-conversation-item items-center';
    if (openChat.active) {
      className = `${className} anchor-chat-conversation-item--active`
    }
    if (openChat.hasUnreadMessages) {
      className = `${className} anchor-chat-conversation-item--has-unread-messages`
    }
    const ago = moment(openChat.lastMessageTimestamp).fromNow();
    const lastMessageStyle = {};
    if (openChat.subscribedToAnchor) {
      lastMessageStyle.fontStyle = 'italic';
    }
    const displayName = openChat.user.nickname ? openChat.user.nickname : openChat.user.username;
    const displayImageUrl = openChat.user.custom && openChat.user.custom.anchorImage;
    let chatImageStyle = {};
    if(displayImageUrl){
      chatImageStyle.background = `url(${displayImageUrl}) no-repeat center center / cover`;
    }

    const { username } = openChat?.user || {};
    
    let shouldDisplayRedDotIndicator = true;
    
    if (!anchor) {
      const subscription = anchorSubscriptions.find(sub => sub.anchorUsername === username || sub.anchorNickname === username);
      const isSubscribed = !!subscription;
      const isBanned = subscription?.isBanned;
      shouldDisplayRedDotIndicator = isSubscribed && !isBanned;
    }

    return (
      <li
        title={`Chat with ${displayName}`}
        className={className}
        onClick={this.activate}>
        <div className="anchor-chat-conversation-item-avatar flex justify-center items-center"
          style={chatImageStyle}
        >
          {!displayImageUrl && initials(displayName)}
          {openChat.online && <div className="online-indicator"></div>}
        </div>
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <p className="anchor-chat-conversation-partner-username">
              <span>{displayName}</span>
            </p>
            {openChat.lastMessageTimestamp ? (
              <div className="message-from-now">
                {ago === 'a few seconds ago' ? 'Just now' : ago}
              </div>
            ) : null}
          </div>
          <div className="flex justify-between">
            <p
              className="anchor-chat-conversation-last-message"
              style={lastMessageStyle}>
              {openChat.lastMessage}
            </p>
            {shouldDisplayRedDotIndicator && openChat.hasUnreadMessages && (
              <div className="unread-messages-indicator" />
            )}
          </div>
        </div>
      </li>
    );
  }
}

export default ConversationItem;
